import * as React from 'react';
import { Theme } from 'helpers/theme';
import { createUseStyles } from 'react-jss';
import ResetIcon from 'assets/evrimaButtons/Reset.svg';
import UpCaretIcon from 'assets/evrimaButtons/UpCaret.svg';
import LeftCaretIcon from 'assets/evrimaButtons/LeftCaret.svg';
import RightCaretIcon from 'assets/evrimaButtons/RightCaret.svg';
import DownCaretIcon from 'assets/evrimaButtons/DownCaret.svg';
import CCIcon from 'assets/evrimaButtons/CC.svg';
import OMIcon from 'assets/evrimaButtons/OM.svg';
import IMIcon from 'assets/evrimaButtons/IM.svg';
import BWIcon from 'assets/evrimaButtons/BW.svg';
import Invert from 'assets/evrimaButtons/Invert.svg';
import HighPower from 'assets/evrimaButtons/HighPower.svg';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    position: 'relative',
    border: '2px solid #8a8a8a00',
    boxSizing: 'content-box',
    width: '53px',
    height: '33px',

    borderRadius: '6px',
    background: '#CDCDCD',

    cursor: 'pointer',
    userSelect: 'none'
  },
  icon: {
    position: 'absolute',
    fill: '#141414'
  },
  buttonNumber: {
    position: 'absolute',
    color: '#FFF',
    textAlign: 'center',
    fontFamily: 'Clash Display',
    fontSize: '14px',
    fontWeight: '600',

    background: '#141414',
    height: '20px',
    width: '23px'
  },
  mainText: {
    position: 'absolute',
    color: '#141414',
    fontFamily: 'Clash Display',
    fontSize: '11px',
    fontWeight: '600'
  },
  subText: {
    position: 'absolute',
    color: '#141414',
    fontFamily: 'Clash Display',
    fontSize: '8px',
    fontWeight: '600'
  }
}));

export function TopLeftButton(props: React.HTMLAttributes<HTMLDivElement>) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          borderRadius: '4px 0px 0px 0px'
        }}
      >
        7
      </div>
    </div>
  );
}

export function TopMiddleButton(props: React.HTMLAttributes<HTMLDivElement>) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{ left: '50%', top: '0px', transform: 'translate(-50%)' }}
      >
        8
      </div>
      <img
        src={UpCaretIcon}
        className={styles.icon}
        style={{ bottom: '3px', left: '50%', transform: 'translate(-50%)' }}
      />
    </div>
  );
}

export function TopRightButton(props: React.HTMLAttributes<HTMLDivElement>) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{ right: '0px', borderRadius: '0px 4px 0px 0px' }}
      >
        9
      </div>
    </div>
  );
}

export function MiddleLeftButton(props: React.HTMLAttributes<HTMLDivElement>) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{ left: '0px', top: '50%', transform: 'translate(0%, -50%)' }}
      >
        4
      </div>
      <img
        src={LeftCaretIcon}
        className={styles.icon}
        style={{ right: '3px', top: '50%', transform: 'translate(0%, -50%)' }}
      />
    </div>
  );
}

export function MiddleButton(props: React.HTMLAttributes<HTMLDivElement>) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}
      >
        5
      </div>
    </div>
  );
}

export function MiddleRightButton(props: React.HTMLAttributes<HTMLDivElement>) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{ right: '0px', top: '50%', transform: 'translate(0%, -50%)' }}
      >
        6
      </div>
      <img
        src={RightCaretIcon}
        className={styles.icon}
        style={{ left: '3px', top: '50%', transform: 'translate(0%, -50%)' }}
      />
    </div>
  );
}

export function BottomLeftButton(props: React.HTMLAttributes<HTMLDivElement>) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{ bottom: '0px', borderRadius: '0px 0px 0px 4px' }}
      >
        1
      </div>
    </div>
  );
}

export function BottomMiddleButton(
  props: React.HTMLAttributes<HTMLDivElement>
) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{ bottom: '0px', left: '50%', transform: 'translate(-50%)' }}
      >
        2
      </div>
      <img
        src={DownCaretIcon}
        className={styles.icon}
        style={{ top: '3px', left: '50%', transform: 'translate(-50%, 0%)' }}
      />
    </div>
  );
}

export function BottomRightButton(props: React.HTMLAttributes<HTMLDivElement>) {
  const styles = useStyles();

  return (
    <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
      <div
        className={styles.buttonNumber}
        style={{
          right: '0px',
          bottom: '0px',
          borderRadius: '0px 0px 4px 0px'
        }}
      >
        3
      </div>
    </div>
  );
}

interface MakeIconProps {
  mainText: string;
  subText?: string;
  Icon: string;
}
function makeIcon({ mainText, subText, Icon }: MakeIconProps) {
  return (props: React.HTMLAttributes<HTMLDivElement>) => {
    const styles = useStyles();

    return (
      <div {...props} className={`${styles.button} ${props.className ?? ''}`}>
        <div
          className={styles.mainText}
          style={{ top: '4.7px', left: '5.8px' }}
        >
          {mainText}
        </div>
        {subText && (
          <div
            className={styles.subText}
            style={{ bottom: '4px', left: '6.7px' }}
          >
            {subText}
          </div>
        )}
        <img
          src={Icon}
          className={styles.icon}
          style={{ bottom: '5.4px', right: '5.7px' }}
        />
      </div>
    );
  };
}

export const CCButton = makeIcon({
  mainText: 'CC',
  subText: 'K',
  Icon: CCIcon
});
export const OMButton = makeIcon({
  mainText: 'OM',
  subText: 'L',
  Icon: OMIcon
});
export const IMButton = makeIcon({
  mainText: 'IM',
  subText: 'M',
  Icon: IMIcon
});
export const BWButton = makeIcon({
  mainText: 'BW',
  subText: 'N',
  Icon: BWIcon
});
export const InvertButton = makeIcon({
  mainText: 'IN',
  subText: 'O',
  Icon: Invert
});
export const HighPowerButton = makeIcon({
  mainText: 'HP',
  subText: 'P',
  Icon: HighPower
});
export const ResetButton = makeIcon({ mainText: 'RST', Icon: ResetIcon });
